<script >
  import RLTS from "@/components/RLTS.vue"

  export default {
    name: "AppProjet-RLTS",
    components: {
      RLTS,
    },
  }
</script>

<template>
  <RLTS />
</template>

<style>

</style>